export const EVERYONE_GROUP_ID = '0';
export const EVERYONE_GROUP_NAME = 'Everyone';

export const everyoneGroup = { usergroup: { id: EVERYONE_GROUP_ID, name: EVERYONE_GROUP_NAME }, canModerate: false };
